/**
 * Unified widget preset lookup — templates (step 1) and row presets (custom "Add widget").
 */

import {
  WIDGET_PRESETS,
  DEFAULT_WIDGET_PRESET_ID,
  getWidgetPresetById,
} from './dashboardWidgetPresets';
import {
  DASHBOARD_TEMPLATES,
  CUSTOM_DASHBOARD_TEMPLATE_ID,
  DEFAULT_DASHBOARD_TEMPLATE_ID,
  DEFAULT_TEMPLATE_CHOOSER_ID,
  STANDARD_DASHBOARD_TEMPLATE,
  STANDARD_DASHBOARD_TEMPLATE_ID,
  getTemplateById,
} from './dashboardTemplates';
import {
  ACCOUNT_360_STANDARD_LAYOUT,
  ACCOUNT_360_STANDARD_TEMPLATE_ID,
  getAccount360TemplateById,
} from './account360StandardLayout';

export {
  WIDGET_PRESETS,
  DASHBOARD_TEMPLATES,
  CUSTOM_DASHBOARD_TEMPLATE_ID,
  DEFAULT_WIDGET_PRESET_ID,
  DEFAULT_DASHBOARD_TEMPLATE_ID,
  DEFAULT_TEMPLATE_CHOOSER_ID,
  STANDARD_DASHBOARD_TEMPLATE,
  STANDARD_DASHBOARD_TEMPLATE_ID,
  ACCOUNT_360_STANDARD_LAYOUT,
  ACCOUNT_360_STANDARD_TEMPLATE_ID,
  getWidgetPresetById,
  getTemplateById,
  getAccount360TemplateById,
};

export const getPresetById = (id) => (
  getTemplateById(id) || getAccount360TemplateById(id) || getWidgetPresetById(id)
);
